import React from 'react';
import DashboardMap from './DashboardMap';
import { Typography } from 'antd';

const { Title } = Typography;

const Dashboard = () => {
    return (
        <div>
            <Title level={2}>AHEAD Dashboard - Survey Locations</Title>
            <DashboardMap />
        </div>
    );
};

export default Dashboard;